import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";

export default function PresencesHistory() {
  const [sessions, setSessions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  function getToken() {
    const token = localStorage.getItem("membreToken");
    if (!token) {
      navigate("/login");
      return null;
    }
    return token;
  }

  useEffect(() => {
    loadSessions();
  }, []);

  async function loadSessions() {
    const token = getToken();
    if (!token) return;

    setLoading(true);

    const res = await fetch("/api/presence?action=sessions", {
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    if (res.status === 403) {
      localStorage.removeItem("membreToken");
      navigate("/login");
      return;
    }

    const json = await res.json();
    setSessions(json.sessions || []);
    setLoading(false);
  }

  async function loadPresences(session) {
    const token = getToken();
    if (!token) return;

    setSelected(session);

    const res = await fetch(
      `/api/presence?action=bySession&session_id=${session.id}`,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );

    if (res.status === 403) {
      localStorage.removeItem("membreToken");
      navigate("/login");
      return;
    }

    const json = await res.json();
    setRows(json.data || []);
  }

  function exportExcel() {
    const sheet = XLSX.utils.json_to_sheet(rows);
    const book = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(book, sheet, "Présences");
    XLSX.writeFile(book, `presences_${selected.date}.xlsx`);
  }

  if (loading) return <p className="p-6">Chargement…</p>;

  return (
    <div className="p-4 md:p-6 max-w-6xl mx-auto">
      <h1 className="text-xl md:text-2xl font-bold mb-6">
        📊 Historique des présences
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        {sessions.map((s) => (
          <button
            key={s.id}
            onClick={() => loadPresences(s)}
            className={`p-4 rounded-xl shadow text-left border transition
              ${
                selected?.id === s.id
                  ? "bg-blue-600 text-white"
                  : "bg-white hover:bg-gray-100"
              }`}
          >
            <p className="font-bold">📅 {s.date}</p>
            <p className="text-sm opacity-80">
              {s.active ? "🟢 Active" : "🔒 Clôturée"}
            </p>
          </button>
        ))}
      </div>

      {selected && (
        <>
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4">
            <h2 className="text-lg md:text-xl font-semibold">
              Session du {selected.date}
            </h2>

            <button
              onClick={exportExcel}
              className="bg-green-600 text-white px-4 py-2 rounded-lg font-semibold"
            >
              ⬇ Export Excel
            </button>
          </div>

          <div className="block md:hidden space-y-4">
            {rows.length === 0 && (
              <p className="text-center text-gray-500">
                Aucun membre enregistré
              </p>
            )}

            {rows.map((r, i) => (
              <div
                key={i}
                className="bg-white rounded-xl shadow p-4 flex justify-between items-center"
              >
                <div>
                  <p className="font-bold text-blue-700">
                    {r.prenom} {r.nom}
                  </p>
                  <p className="text-xs text-gray-500">
                    ID : {r.member_id}
                  </p>

                  <p
                    className={`mt-1 text-sm font-semibold ${
                      r.status === "present"
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    {r.status === "present" ? "Présent" : "Absent"}
                  </p>
                </div>

                <div className="text-sm font-mono text-gray-700">
                  {r.scanned_at ? r.scanned_at.slice(11, 19) : "—"}
                </div>
              </div>
            ))}
          </div>

          <div className="hidden md:block">
            <table className="w-full bg-white shadow rounded-xl overflow-hidden">
              <thead className="bg-gray-200 text-left">
                <tr>
                  <th className="p-3">ID</th>
                  <th className="p-3">Nom</th>
                  <th className="p-3">Statut</th>
                  <th className="p-3">Heure</th>
                </tr>
              </thead>

              <tbody>
                {rows.map((r, i) => (
                  <tr key={i} className="border-t hover:bg-gray-50">
                    <td className="p-3">{r.member_id}</td>
                    <td className="p-3">
                      {r.prenom} {r.nom}
                    </td>
                    <td
                      className={`p-3 font-semibold ${
                        r.status === "present"
                          ? "text-green-600"
                          : "text-red-600"
                      }`}
                    >
                      {r.status}
                    </td>
                    <td className="p-3">
                      {r.scanned_at ? r.scanned_at.slice(11, 19) : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
